import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const DatasourceUpstreamFlowsWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query DatasourceUpstreamFlowsWithoutPersonalSpaceQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  publishedDatasources(filter: { vizportalUrlId: $vizportalUrlId }) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
